import type { WSRequestsBody } from '@patrianna/shared-patrianna-types/websocket/requests'
import { v4 as uuid } from 'uuid'

export class KeepAlive {
  socketRoot: null | WebSocket = null
  keepAliveTimer: ReturnType<typeof setTimeout> | undefined = undefined

  send = (event: WSRequestsBody) => {
    if (this.socketRoot?.readyState === WebSocket.OPEN) {
      this.socketRoot.send(
        JSON.stringify({
          headers: { messageId: uuid(), timestamp: Date.now() },
          body: event,
        }),
      )
    } else {
      console.info('readyState', this.socketRoot?.readyState, event)
    }
  }

  polling = () => {
    this.send({ type: 'KeepAliveRequest' })
    this.keepAliveTimer = setTimeout(this.polling, 15000)
  }
  stopPolling = () => {
    clearTimeout(this.keepAliveTimer)
  }

  initSocket = (socketRoot: WebSocket) => {
    this.socketRoot = socketRoot
  }
  clearSocket = () => {
    this.socketRoot = null
  }
}
